import React, { useState, useEffect } from 'react';
import { Form, Row, Col, InputGroup, Button, Badge, Card, Modal } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from 'react-spinners/ClipLoader';
import { handlerErrors, handleAPIError } from 'utils/handleErrors';
import ButtonRequest from 'components/buttons/ButtonRequest';
import TrackingStatuses from './TrackingStatuses';
import TrackingChannels from './TrackingChannels';
import { updateInternalNotifications } from '../../../../api/Api-user';

const InternalNotifications = ({ configData, setTrigger }) => {
  const isActive = configData.user_profile.internal_notifications_enabled;
  // const [isActive, setIsActive] = useState(configData.user_profile.internal_notifications_enabled);
  const [selectedState, setSelectedState] = useState(configData.user_profile.internal_notification_statuses);
  const [selectedChannels, setSelectedChannels] = useState(configData.user_profile.internal_channels);
  const [emails, setEmails] = useState(configData.user_profile.internal_emails);
  const [isConfNotifications, setIsConfNotifications] = useState(false);
  const [deleteNotifications, setDeleteNotifications] = useState(false);
  const [isModalToggleOpen, setIsModalToggleOpen] = useState(false);
  // console.log('configData:', configData);
  // console.log('internal status selected:', selectedState);
  const [inputValue, setInputValue] = useState('');

  // Agregar correo al presionar Enter
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      if (!emails.includes(inputValue.trim())) {
        setEmails([...emails, inputValue.trim()]);
      }
      setInputValue('');
      e.preventDefault();
    }
  };
  // Función que agrega un correo
  const addEmail = () => {
    const value = inputValue.trim();
    if (value && !emails.includes(value)) {
      setEmails([...emails, value]);
    }
    setInputValue('');
  };
  // Eliminar correo
  const removeEmail = (index) => {
    const newEmails = emails.filter((_, i) => i !== index);
    setEmails(newEmails);
  };
  const handleToggleNotifications = async () => {
    try {
      setIsConfNotifications(true);
      const response = await updateInternalNotifications({
        internal_notifications_enabled: true,
        internal_notification_statuses: selectedState,
        internal_channels: selectedChannels,
        internal_emails: emails,
      });
      // console.log(response);
      if (response.data.success !== undefined) {
        toast.success(response.data.message, {
          position: 'top-right',
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        });
        setTrigger((prev) => !prev);
      }
      // else if (response.error) {
      //   handleAPIError(response);
      // }
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsConfNotifications(false);
    }
  };
  const handlerDeactivateNotifications = async () => {
    try {
      setIsConfNotifications(true);
      const response = await updateInternalNotifications({
        internal_notifications_enabled: false,
        internal_notification_statuses: [],
        internal_channels: [],
        internal_emails: [],
      });
      // console.log(response);
      if (response.data.success !== undefined) {
        toast.success(response.data.message, {
          position: 'top-right',
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        });
      }
      setTrigger((prev) => !prev);
      setIsModalToggleOpen(false);
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsConfNotifications(false);
    }
  };

  return (
    <>
      <Modal
        show={isModalToggleOpen}
        onHide={() => {
          setIsModalToggleOpen(false);
          setDeleteNotifications(false);
        }}
      >
        <Modal.Header closeButton>
          {/* <Modal.Title className="text-primary">
            <div className="text-primary"> </div>{' '}
          </Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="bg-infow">
          <div className="text-semi-large mb-4">
            ¿Confirmas que deseas <strong>desactivar</strong> las notificaciones internas?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex flex-wrap justify-content-end bg-warningd">
            <Button
              variant="outline-primary"
              style={{ height: '36px' }}
              className="w-auto me-2 mb-2"
              onClick={() => {
                setIsModalToggleOpen(false);
                setDeleteNotifications(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="xl"
              // className="mx-2"
              className="py-0"
              onClick={handlerDeactivateNotifications}
              style={{ height: '36px' }}
            >
              {isConfNotifications && <ClipLoader disabled={isConfNotifications} color="#FFFFFF" loading={isConfNotifications} size={10} />}
              {isConfNotifications ? 'Si, continuar' : 'Si, continuar'}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Row>
        <Col xl="8" className="order-2 order-xl-1">
          <h2 className="small-title invisible">Configuración</h2>
          <Card>
            <Card.Body>
              <h1 className="display-4">{isActive ? 'Editar notificaciones' : 'Activar notificaciones de mis envíos'}</h1>
              <div>
                {isActive ? (
                  'Tus notificaciones están activas. Puedes editar la configuración en cualquier momento.'
                ) : (
                  <>
                    Configura esta opción para <strong>recibir</strong> reportes automáticos de seguimiento de tus envíos.
                  </>
                )}
              </div>
              <Form>
                <Row className="pt-5">
                  <Col xs="12" className="mb-3">
                    <TrackingStatuses
                      statuses={configData.available_notification_statuses.tracking_statuses}
                      selectedState={selectedState}
                      setSelectedState={setSelectedState}
                      type="internal"
                    />
                  </Col>
                  <Col xs="12" className="mb-3">
                    <TrackingChannels
                      channels={configData.available_notification_statuses.internal_channels}
                      selectedChannels={selectedChannels}
                      setSelectedChannels={setSelectedChannels}
                      type="internal"
                    />
                  </Col>
                  <Col xs="12" xl="10" className="mb-3">
                    <Form.Label> 3. Correos para recibir las notificaciones internas.</Form.Label>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '15px' }}>
                      {emails.map((email, index) => (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#e0e0e0',
                            borderRadius: '16px',
                            padding: '4px 8px',
                          }}
                        >
                          <span>{email}</span>
                          <button
                            onClick={() => removeEmail(index)}
                            type="button"
                            // className="bg-info"
                            style={{
                              marginLeft: '6px',
                              background: 'transparent',
                              border: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            <CsLineIcons icon="close" size="14" className="text-alternate" />
                          </button>
                        </div>
                      ))}
                    </div>
                    <Form.Text className="d-block mb-2">
                      Ingresa los correos electrónicos donde deseas recibir las notificaciones internas. Puedes agregar uno o varios.
                    </Form.Text>
                    <InputGroup>
                      <InputGroup.Text>
                        <CsLineIcons icon="email" size="16" className="text-alternate" />
                      </InputGroup.Text>
                      <Form.Control
                        type="email"
                        placeholder="Escribe un correo y presiona Enter o haz clic en Agregar"
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        value={inputValue}
                      />
                    </InputGroup>
                    <Button variant="outline-primary" className="btn-icon btn-icon-start w-auto mt-3" onClick={addEmail}>
                      <CsLineIcons icon="plus" className="me-1" />
                      <span>Agregar</span>
                    </Button>
                    {/* <pre>{JSON.stringify(emails, null, 2)}</pre> */}
                  </Col>
                  <Col xs="12" className="my-5">
                    <ButtonRequest
                      title={isActive ? 'Actualizar configuración' : 'Guardar y activar'}
                      titleLoading={isActive ? 'Editando' : 'Activar'}
                      handlerFn={handleToggleNotifications}
                      isButtonDisabled={isConfNotifications}
                      isLoading={isConfNotifications}
                    />
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        <Col xl="4" className="order-1 order-xl-2">
          <h2 className="small-title">Estado</h2>
          <Card className="mb-3">
            <Card.Body>
              <div>
                <div className="cta-4 mb-2">Notificaciones Internas:</div>
                <Badge bg={isActive ? 'success' : 'danger'} className="text-uppercase fw-bolder" style={{ fontSize: '12px' }}>
                  <span>{isActive ? 'Activas' : 'Inacivas'}</span>
                </Badge>
                {isActive && (
                  <div className="bg-warningx d-flex my-3">
                    <span className="me-1 d-flex aling-items-end bg-infox">¿Deseas desactivar estas notificaciones?</span>
                    <Form.Check // prettier-ignore
                      type="switch"
                      //  id="switch_insurance"
                      className="bg-successx d-flex aling-items-end"
                      checked={deleteNotifications}
                      onChange={() => {
                        setIsModalToggleOpen(true);
                        setDeleteNotifications(!deleteNotifications);
                      }}
                    />
                  </div>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default InternalNotifications;
